const flat = (byField) => Object.values(byField || {}).flat()

/** Waar elke collectie in de openbare definitie staat. Al op Position gesorteerd. */
const DOC_SOURCES = {
    QuestionnaireFields: (data) => data.fields || [],
    MultipleQuestionOptions: (data) => flat(data.options),
    MatrixQuestionRows: (data) => flat(data.matrixRows),
    MatrixQuestionColumns: (data) => flat(data.matrixColumns),
}

/**
 * Een kleine, alleen-lezen nabootsing van `db` voor getQuestionnaire, gevuld
 * met wat getPublicQuestionnaire teruggaf. Zo leest de AI-interviewer op de
 * openbare pagina dezelfde definitie als de rest van het formulier, zonder
 * Firestore (anoniem mag dat niet meer). Kent alleen de vragen die
 * getQuestionnaire stelt: `where(veld, '==', waarde)`, `orderBy`, `get`.
 *
 * @param {import('../../../StateManagment/PublicQuestionnaireContext').PublicQuestionnaireData} data
 */
const publicQuestionnaireDb = (data) => ({
    collection: (name) => {
        const source = DOC_SOURCES[name]
        if (!source) throw new Error(`publicQuestionnaireDb: ${name} zit niet in de openbare definitie`)
        const query = (filters) => ({
            where: (field, op, value) => query([...filters, [field, value]]),
            orderBy: () => query(filters),
            get: async () => ({
                docs: source(data)
                    .filter((d) => filters.every(([field, value]) => d[field] === value))
                    .map((d) => ({ id: d.docid, data: () => d })),
            }),
        })
        return query([])
    },
})

export default publicQuestionnaireDb
